import { MainNavElement } from "type/navigation/main_navigation.type";

export const NEW_ITEM_NAV_ELEMENTS: MainNavElement[] = [
  { title: "Video", path: "/video/new" },
  { title: "Position", path: "/position/new" },
  { title: "Panel", path: "/panel/new" },
];

export const NEW_LIST_MAIN_NAV_ELEMENTS: MainNavElement[] = [
  { title: "Video list", path: "/video/list" },
  { title: "Position list", path: "/position/list" },
  { title: "Panel list", path: "/panel/list" },
  { title: "Unos", path: "/unos" },
];

export const GENERAL_NAV_ELEMENTS: MainNavElement[] = [
  { title: "Uputstvo", path: "/uputstvo" },
];
